import styled from 'styled-components'

import theme from '~/shared/styles/theme'

interface Props {
  title: string
  description?: string
  background?: string
  image?: string
  tab?: any
}

function CircleInfoTopSection({
  title,
  description,
  background,
  image,
}: Props) {
  return (
    <Wrapper>
      <Title dangerouslySetInnerHTML={{ __html: title }} />
      <BackgroundImage src={background} alt="" />
      <HerneImage src={image} alt="" />
      {description && (
        <Desc dangerouslySetInnerHTML={{ __html: description }} />
      )}
    </Wrapper>
  )
}

export default CircleInfoTopSection

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 36px;
  align-items: flex-start;

  box-sizing: border-box;
  margin-top: 124px;

  @media ${theme.device.large} {
    gap: 20px;
    height: auto;
  }

  @media ${theme.device.medium} {
    gap: 24px;
    margin-top: 56px;
  }
`

const BackgroundImage = styled.img`
  position: absolute;
  z-index: ${theme.zIndex.belowBackground};
  top: 0;
  left: 0;

  overflow: hidden;

  width: 100%;
  height: 555px;

  @media ${theme.device.large} {
    height: auto;
  }
`

const HerneImage = styled.img`
  position: absolute;
  z-index: ${theme.zIndex.belowBackground};
  top: 0;
  right: 0;

  width: 100%;
  height: 564px;

  @media ${theme.device.large} {
    left: 0;
    height: 350px;
  }

  @media ${theme.device.medium} {
    height: 0;
  }
`

const Title = styled.h1`
  font-family: NanumSquareNeo-Heavy, sans-serif;
  font-size: 42px;
  font-weight: 700;
  line-height: 59px;
  text-align: left;
  white-space: pre-line;

  @media ${theme.device.medium} {
    width: 100%;
    height: auto;
    font-size: 28px;
    line-height: 40px;
  }
`

const Desc = styled.p`
  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
  text-align: left;
  white-space: pre-line;

  @media ${theme.device.medium} {
    width: 100%;
    height: auto;
    font-size: 16px;
    line-height: 28px;
  }
`
